import Axios from "axios";
import { CachePocily } from "../common/Cache";
import cacheKey from "../constant/cacheKey";
var AccoutCheckService = (function () {
    function AccoutCheckService() {
    }
    AccoutCheckService.prototype.getGroupchilds = function (params) {
        return Axios.get("supplierclientapi/customer/group_childs", { params: params });
    };
    AccoutCheckService.prototype.getShopList = function (id, supplier_to_business_id) {
        return Axios.get("supplierclientapi/shop/shop_list", { params: { business_id: id, supplier_to_business_id: supplier_to_business_id } });
    };
    AccoutCheckService.prototype.getShopAny = function (params) {
        return Axios.get("supplierclientapi/shop/shop_list", { params: params });
    };
    AccoutCheckService.prototype.getRecordList = function (params) {
        return Axios.get("supplierclientapi/statementorder/get_receivable_list", { params: params });
    };
    AccoutCheckService.prototype.getAddCheckDetail = function (params) {
        return Axios.get("supplierclientapi/statementorder/create_statement_order", { params: params });
    };
    AccoutCheckService.prototype.create = function (data) {
        return Axios.post("supplierclientapi/statementorder/save_create_statement_order", data);
    };
    AccoutCheckService.prototype.getOrderList = function (params) {
        return Axios.get("supplierclientapi/statementorder/get_statement_order_list", { params: params });
    };
    AccoutCheckService.prototype.getEditCheckDetail = function (params) {
        return Axios.get("supplierclientapi/statementorder/edit_statement_order", { params: params });
    };
    AccoutCheckService.prototype.edit = function (data) {
        return Axios.post("supplierclientapi/statementorder/save_edit_statement_order", data);
    };
    AccoutCheckService.prototype.getStatus = function () {
        return CachePocily.getInstance().getDataPromise(cacheKey.ACCOUNT_CHECK_STATUS, function () { return Axios.get("supplierclientapi/statementorder/get_statement_order_status"); });
    };
    AccoutCheckService.prototype.confirm = function (params) {
        return Axios.get("supplierclientapi/statementorder/confirm_statement_order", { params: params });
    };
    AccoutCheckService.prototype.submit = function (params) {
        return Axios.get("supplierclientapi/statementorder/submit_statement_order", { params: params });
    };
    AccoutCheckService.prototype.deleteOrder = function (order_id) {
        return Axios.get("supplierclientapi/statementorder/cancel_statement_order", { params: { order_id: order_id } });
    };
    AccoutCheckService.prototype.getDetail = function (params) {
        return Axios.get("supplierclientapi/statementorder/get_statement_order_detail", { params: params });
    };
    AccoutCheckService.prototype.createPaymentOrder = function (data) {
        return Axios.post("supplierclientapi/statementorder/payment_statement_order", data);
    };
    AccoutCheckService.prototype.getGoodList = function (params) {
        return Axios.get("supplierclientapi/statementorder/detail_goods_list", { params: params });
    };
    AccoutCheckService.prototype.getGoodsType = function (params) {
        return Axios.get("supplierclientapi/statementorder/goods_type", { params: params });
    };
    AccoutCheckService.prototype.updateInvoice = function (data) {
        return Axios.post("supplierclientapi/statementorder/save_order_document", data);
    };
    AccoutCheckService.prototype.getSignStatus = function (data) {
        return Axios.post("supplierclientapi/statementorder/get_sign_status", data);
    };
    AccoutCheckService.createInstance = function () {
        AccoutCheckService.getInstance();
    };
    AccoutCheckService.getInstance = function () {
        return this._instance || (this._instance = new this());
    };
    AccoutCheckService.prototype.getOrderDocumentList = function (params) {
        return Axios.get("supplierclientapi/statementorder/order_document_list", { params: params });
    };
    AccoutCheckService.prototype.getSignList = function (params) {
        return Axios.get("supplierclientapi/statementorder/sign_img_list", { params: params });
    };
    AccoutCheckService.prototype.deleteOrderDocument = function (params) {
        return Axios.get("supplierclientapi/statementorder/delete_order_document", { params: params });
    };
    AccoutCheckService.prototype.renameOrderDocument = function (params) {
        return Axios.get("supplierclientapi/statementorder/rename_order_document", { params: params });
    };
    AccoutCheckService.prototype.downOrderDocument = function (params) {
        return Axios.get("supplierclientapi/statementorder/download_order_document", { params: params });
    };
    AccoutCheckService.prototype.confirmOrderDocument = function (params) {
        return Axios.get("supplierclientapi/statementorder/confirm_order_document", { params: params });
    };
    AccoutCheckService.prototype.latestSignImg = function (params) {
        return Axios.get("supplierclientapi/statementorder/latest_sign_img", { params: params });
    };
    AccoutCheckService.prototype.rejectStatementOrder = function (params) {
        return Axios.get("supplierclientapi/statementorder/reject_statement_order", { params: params });
    };
    AccoutCheckService.prototype.refreshOrderDocument = function (params) {
        return Axios.get("supplierclientapi/statementorder/refresh_order_document", { params: params });
    };
    AccoutCheckService.prototype.getCompanyByKeyword = function (params) {
        return Axios.get("supplierclientapi/companyinfo/get_company_info_list", { params: params });
    };
    AccoutCheckService.prototype.getCompanyInfo = function (params) {
        return Axios.get("supplierclientapi/companyinfo/get_company_info", { params: params });
    };
    AccoutCheckService.prototype.updateInvoiceInfo = function (data) {
        return Axios.post("supplierclientapi/statementorder/update_invoice_info", data);
    };
    AccoutCheckService.prototype.isOpenBaiWang = function (params) {
        return Axios.get("supplierclientapi/statementorder/invoice_account_info", { params: params });
    };
    AccoutCheckService.prototype.generateInvoiceAccount = function (data) {
        return Axios.post("supplierclientapi/statementorder/open_invoice_account", data);
    };
    AccoutCheckService.prototype.bindOrg = function (data) {
        return Axios.post("supplierclientapi/statementorder/invoice_bind_organ", data);
    };
    AccoutCheckService.prototype.getInvoiceGoods = function (params) {
        return Axios.get("supplierclientapi/statementorder/order_document_preview", { params: params });
    };
    AccoutCheckService.prototype.createOrderDocument = function (data) {
        return Axios.post("supplierclientapi/statementorder/create_third_order_document", data);
    };
    AccoutCheckService.prototype.getGoodsCategory = function (params) {
        return Axios.get("supplierclientapi/suppliergoods/goods_tax_type_search", { params: params });
    };
    AccoutCheckService.prototype.getProvince = function () {
        return Axios.get("basicapi/invoice_area");
    };
    AccoutCheckService.prototype.getThirdInvoice = function (params) {
        return Axios.get("supplierclientapi/statementorder/get_third_order_document", { params: params });
    };
    return AccoutCheckService;
}());
export default AccoutCheckService;
